'use client'

import { FC } from 'react'

import { nanoid } from 'nanoid'

import { BodyProps } from '../../types'

const Body: FC<BodyProps> = ({
  bodyData,
  className = '',
  classNameLine = '',
  classNameCell = '',
  onClick,
}) => {
  const getKeys = (): string[] => {
    if (bodyData?.length === 0) return []
    return Object.keys(bodyData[0])
  }

  const keys = getKeys()

  return (
    <div className={`grid gap-2 ${className}`}>
      {keys?.length
        ? bodyData.map((item, index) => (
            <div
              onClick={() => onClick && onClick(index)}
              key={nanoid()}
              className={`grid items-center gap-4 rounded bg-white cursor-pointer hover:bg-[#5a53f71a] border border-white hover:border hover:border-primary transition-colors duration-100 ${classNameLine}`}
            >
              {keys.map((key) => (
                <div key={nanoid()} className={`${classNameCell}`}>
                  {item[key]}
                </div>
              ))}
            </div>
          ))
        : null}
    </div>
  )
}

export default Body
